export const ZodEnumLabels = {
    id: 'ZodEnumLabels',
    value: (Schema) => ({
        enumLabels: {
            get() {
                return this._def.enumLabels || this.Enum;
            }
        },
        setEnumLabels: {
            value(enumLabels) {
                return new Schema({
                    ...this._def,
                    enumLabels
                });
            }
        }
    })
};
